import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');

    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('感谢订阅！我们会将佐山爱的最新动态发送到您的邮箱。');
      setEmail('');
      return;
    }

    try {
      const params = new URLSearchParams();
      params.append('email', email);
      const response = await fetch('https://readdy.ai/api/form/d9u580f8l97n3eas3hkg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch {}
      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会将佐山爱的最新动态发送到您的邮箱。');
        setEmail('');
      } else {
        setStatus('error');
        setMessage(parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试。');
      }
    } catch (_err) {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <section className="py-12 md:py-14 bg-accent-500">
      <div className="w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 rounded-xl bg-background-50/20">
          <i className="ri-mail-send-line text-2xl text-background-50"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
          订阅更新
        </h2>
        <p className="text-sm text-background-50/80 mb-6">
          第一时间获取佐山爱的最新动态、写真作品和独家内容
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto" data-readdy-form="">
          <div className="honeypot-wrapper">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入您的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-lg bg-background-50 text-foreground-900 text-sm placeholder:text-foreground-400 border border-transparent focus:outline-none focus:ring-2 focus:ring-background-50/30 font-label"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="whitespace-nowrap cursor-pointer px-6 py-3 rounded-lg bg-foreground-900 text-background-50 text-sm font-label hover:bg-foreground-800 transition-colors disabled:opacity-60"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {message && (
          <p className={`mt-4 text-sm ${status === 'success' ? 'text-background-50' : 'text-background-50/90'}`}>
            {message}
          </p>
        )}
      </div>
    </section>
  );
}